const STATISTIC = '/v2/statistic';

export function offerSummaryStatistic(): string {
  return `${STATISTIC}/offer/summary`;
}
